export type AiAssistantDisclaimerKey =
  | 'ai-supervisor'
  | 'ai-abstract'
  | 'ai-homework'
  | 'ai-metaphor'
  | 'ai-mac-technique'
  | 'ai-therapy-plan'
  | 'ai-coach-supervisor'
  | 'ai-tales-therapist'
  | 'ai-transcription';

const baseDisclaimer =
  'Данное заключение сгенерировано ИИ-супервизором платформы ZiNGiZi на основе текстовой расшифровки, которая автоматически удаляется после сессии. Важно понимать, что ИИ-супервизор **НЕ ЯВЛЯЕТСЯ** и **НЕ МОЖЕТ ЗАМЕНИТЬ** живого супервизора — опытного специалиста-человека.\n\nЦель данного инструмента — не замена, а дополнение и поддержка работы психолога. Это — «второе мнение» на основе данных, помощник в структурировании мыслительного процесса, но не истина в последней инстанции. Все выводы и гипотезы, предложенные ИИ, должны быть критически осмыслены и переработаны специалистом с опытом и профессиональной этикой';

const abstractDisclaimer =
  'Конспект составлен ИИ-ассистентом психолога на основе анализа текстовой расшифровки сессии и должен быть обязательно скорректирован психологом с учетом полного контекста, невербальных реакций клиента и клинической целесообразности. После ИИ обработки запись удаляется.';

const homeworkDisclaimer =
  'Предложенное домашнее задание является рекомендацией ИИ-супервизора на основе анализа текстовой расшифровки сессии и должно быть обязательно адаптировано, скорректировано или заменено психологом с учетом полного контекста, невербальных реакций клиента и клинической целесообразности.';

const metaphorDisclaimer =
  'Предложенные метафоры являются рекомендацией ИИ-супервизора на основе анализа текстовой расшифровки сессии и должны быть обязательно скорректированы психологом с учётом полного контекста, невербальных реакций клиента и клинической целесообразности.';

const coachDisclaimer =
  'Заключение составлено ИИ-ассистентом на основе анализа текстовой расшифровки коучинговой сессии и должно быть обязательно скорректировано с учетом полного контекста, невербальных реакций клиента.';

const taleDisclaimer ='Предложенная сказка является рекомендацией ИИ-сказкотерапевта на основе анализа текстовой расшифровки сессии и должна быть обязательно скорректирована или заменена психологом с учетом полного контекста, невербальных реакций клиента и клинической целесообразности.';
const transcriptionDisclaimer =
  'Транскрипция формируется автоматически и может содержать неточности. Проверьте текст перед использованием в работе.';

const macTechniqueDisclaimer = 'Скоро появится!\n\n' +
          'Мы готовим для вас кое-что особенное — авторскую 5-шаговую МАК-технику. Вас ждут готовые вопросы для сессии и точные рекомендации по подбору колод из каталога ZiNGiZi. \n\n' +
          'Приглашайте своих коллег — вместе вы сможете первыми опробовать новый инструмент в работе!';

export const aiAssistantDisclaimers: Record<AiAssistantDisclaimerKey, string> = {
  'ai-supervisor': baseDisclaimer,
  'ai-abstract': abstractDisclaimer,
  'ai-homework': homeworkDisclaimer,
  'ai-metaphor': metaphorDisclaimer,
  'ai-mac-technique': macTechniqueDisclaimer,
  'ai-therapy-plan': baseDisclaimer,
  'ai-coach-supervisor': coachDisclaimer,
  'ai-tales-therapist': taleDisclaimer,
  'ai-transcription': transcriptionDisclaimer,
};
